module.exports = __webpack_public_path__ + "static/media/21_B.c09209ed.png";